/**
 * dg-free-shipping-fx.js  v7.2 — Zone-aware free shipping bar
 *
 * Zones détectées par code postal COMPLET (6 caractères) :
 *   La Tuque    → tous les G9X SAUF exceptions ci-dessous → seuil 100$ (10000 cents)
 *   Région      → G9X0A7, G9X3N7, G9X3N8 uniquement      → seuil 250$ (25000 cents)
 *   Hors zone   → tout autre code postal
 *
 * Lookup stocké en localStorage sous 'dg_postal_zone'
 * Format: { postal: 'G9X1E4', zone: 'latuque'|'region'|'hors', threshold: 10000|25000 }
 */
(function () {
    'use strict';

    var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var LS_KEY = 'dg_postal_zone';

    /* ── Codes G9X qui sont région (250$) — La Bostonnais, La Croche, Lac-à-Beauce ── */
    var G9X_REGION_EXCEPTIONS = {
        'G9X0A7': true,  // La Bostonnais
        'G9X3N7': true,  // La Croche
        'G9X3N8': true   // Lac-à-Beauce
    };

    /* ── Zone configuration ── */
    var ZONES = {
        latuque: {
            threshold: 10000,   // 100$
            label: '100$',
            name: 'La Tuque'
        },
        region: {
            threshold: 25000,   // 250$
            label: '250$',
            name: 'ta région'
        },
        wemontaci: {
            threshold: 25000,   // 250$ (même seuil que région)
            label: '250$',
            name: 'Wemotaci'
        }
    };

    /* ── State ── */
    var THRESHOLD = 10000; // default until postal known
    var currentZone = null;
    var hasCelebratedFree = false;
    var prevPct = 0;
    var _deliveryWidgetObserver = null; // tracks body observer for Zapiet cart widget
    var _zapietMenuTextObserver = null;
    var _zapietMenuTextTimer = null;

    function escapeHtml(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    /**
     * Zapiet / MUI injecte souvent le menu des créneaux dans un portail avec des couleurs
     * qui perdent face au thème (texte clair sur fond blanc). Le CSS du thème peut aussi
     * être surchargé par les styles de l’app. On force le texte foncé sur le DOM réel.
     */
    function dgLooksLikeTimeSlotMenu(el) {
        if (!el || !el.textContent) return false;
        var t = el.textContent;
        if (/\d{1,2}:\d{2}/.test(t) && (t.indexOf('AM') >= 0 || t.indexOf('PM') >= 0)) return true;
        if (/\d{1,2}\s*h\s*\d{2}/i.test(t) || /\d{1,2}h\d{2}/i.test(t)) return true;
        return false;
    }

    function dgForceZapietNativeSelects() {
        var roots = document.querySelectorAll(
            '#storePickupApp, #dg-cart-page, #dg-cart-drawer, [class*="zapiet"], [class*="Zapiet"]'
        );
        for (var r = 0; r < roots.length; r++) {
            var root = roots[r];
            if (!root) continue;
            var selects = root.querySelectorAll('select');
            for (var s = 0; s < selects.length; s++) {
                var sel = selects[s];
                sel.style.setProperty('color-scheme', 'light', 'important');
                sel.style.setProperty('color', '#0f172a', 'important');
                sel.style.setProperty('-webkit-text-fill-color', '#0f172a', 'important');
                sel.style.setProperty('background-color', '#ffffff', 'important');
                var opts = sel.querySelectorAll('option');
                for (var o = 0; o < opts.length; o++) {
                    var opt = opts[o];
                    opt.style.setProperty('color', '#0f172a', 'important');
                    opt.style.setProperty('background-color', '#ffffff', 'important');
                    opt.style.setProperty('-webkit-text-fill-color', '#0f172a', 'important');
                }
            }
        }
    }

    function dgPaintMuiPapersWithTimeText() {
        var papers = document.querySelectorAll('[class*="MuiPaper-root"]');
        for (var i = 0; i < papers.length; i++) {
            var root = papers[i];
            if (!root || !dgLooksLikeTimeSlotMenu(root)) continue;
            var st = window.getComputedStyle(root);
            if (st.display === 'none' || st.visibility === 'hidden') continue;
            var nodes = root.querySelectorAll('li, span, p, div');
            for (var j = 0; j < nodes.length; j++) {
                var el = nodes[j];
                if (!el || el.closest('svg')) continue;
                var tag = el.tagName;
                if (tag !== 'LI' && tag !== 'SPAN' && tag !== 'P' && tag !== 'DIV') continue;
                var txt = (el.textContent || '').trim();
                if (txt.length > 140) continue;
                if (!/(AM|PM|\d{1,2}\s*h)/i.test(txt)) continue;
                el.style.setProperty('color', '#0f172a', 'important');
                el.style.setProperty('-webkit-text-fill-color', '#0f172a', 'important');
            }
        }
    }

    function dgPaintMenuItemsWhenFormLight() {
        if (!document.documentElement.classList.contains('dg-form-light')) return;
        var items = document.querySelectorAll(
            '.MuiMenuItem-root, [role="option"], [role="menuitem"]'
        );
        for (var i = 0; i < items.length; i++) {
            var el = items[i];
            if (!el || el.closest('svg')) continue;
            var t = (el.textContent || '').trim();
            if (t.length > 140 || t.length < 4) continue;
            if (!/(AM|PM|\d{1,2}\s*h|\d{1,2}:\d{2})/i.test(t)) continue;
            el.style.setProperty('color', '#0f172a', 'important');
            el.style.setProperty('-webkit-text-fill-color', '#0f172a', 'important');
        }
    }

    function dgApplyZapietSlotMenuTextColors() {
        var candidates = document.querySelectorAll(
            '.MuiPaper-root.MuiMenu-paper, ' +
            '[class*="MuiMenu-paper"], ' +
            '.MuiPopover-paper, ' +
            '[class*="MuiPopover-paper"], ' +
            'ul[role="listbox"], ' +
            'ul[role="menu"]'
        );
        var drawerOpen = document.querySelector('#dg-cart-drawer.active');
        for (var i = 0; i < candidates.length; i++) {
            var root = candidates[i];
            if (!root) continue;
            var inCart = root.closest('#dg-cart-drawer') || root.closest('#storePickupApp');
            var inMuiPortal =
                root.closest('.MuiPopover-root') ||
                root.closest('.MuiModal-root') ||
                root.closest('[class*="MuiPopper-root"]') ||
                root.closest('[class*="MuiPopper"]');
            if (!inCart && !inMuiPortal) {
                if (!(drawerOpen && dgLooksLikeTimeSlotMenu(root))) continue;
            }
            if (!dgLooksLikeTimeSlotMenu(root) && !inCart) continue;

            var st = window.getComputedStyle(root);
            if (st.display === 'none' || st.visibility === 'hidden') continue;

            var nodes = root.querySelectorAll('li, span, p, div[class*="Typography"], div[class*="typography"]');
            for (var j = 0; j < nodes.length; j++) {
                var el = nodes[j];
                if (!el || el.closest('svg')) continue;
                el.style.setProperty('color', '#0f172a', 'important');
                el.style.setProperty('-webkit-text-fill-color', '#0f172a', 'important');
            }
        }

        dgPaintMuiPapersWithTimeText();
        dgForceZapietNativeSelects();
        dgPaintMenuItemsWhenFormLight();
    }

    function dgScheduleZapietSlotMenuTextColors() {
        if (_zapietMenuTextTimer) clearTimeout(_zapietMenuTextTimer);
        _zapietMenuTextTimer = setTimeout(function () {
            _zapietMenuTextTimer = null;
            dgApplyZapietSlotMenuTextColors();
        }, 50);
    }

    function dgStartZapietSlotMenuTextFix() {
        window.DG_applyZapietSlotMenuTextColors = dgApplyZapietSlotMenuTextColors;
        dgApplyZapietSlotMenuTextColors();
        if (_zapietMenuTextObserver) return;
        _zapietMenuTextObserver = new MutationObserver(function () {
            dgScheduleZapietSlotMenuTextColors();
        });
        _zapietMenuTextObserver.observe(document.body, { childList: true, subtree: true });
        document.addEventListener(
            'click',
            function () {
                setTimeout(dgApplyZapietSlotMenuTextColors, 50);
                setTimeout(dgApplyZapietSlotMenuTextColors, 250);
            },
            true
        );
    }

    /* ── Money formatter ── */
    function fmt(cents) {
        cents = parseInt(cents, 10) || 0;
        return '$' + (cents / 100).toFixed(2);
    }

    /* ── SVGs ── */
    var truckSvg = '<svg style="width:16px;height:16px;vertical-align:middle;margin-right:5px;color:#fff;filter:drop-shadow(0 1px 3px rgba(0,0,0,0.5))" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"/><path d="M3 9h4"/></svg>';
    var checkSvg = '<svg style="width:18px;height:18px;vertical-align:middle;margin-right:6px;color:#fff;filter:drop-shadow(0 0 4px rgba(255,255,255,0.5))" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M5 12l5 5l10 -10"/></svg>';

    /* ── Determine zone from postal code (full 6-char lookup) ── */
    function detectZone(rawPostal) {
        if (!rawPostal) return null;
        var clean = rawPostal.replace(/\s/g, '').toUpperCase().substring(0, 6);
        
        // Exiger un code postal complet (6 caractères)
        if (clean.length < 6) {
            return { key: 'invalid_length', zone: null, postal: clean };
        }
        
        var prefix3 = clean.substring(0, 3);

        // G0X → Wemotaci (250$ free shipping)
        if (prefix3 === 'G0X') {
            if (clean === 'G0X3R0') {
                return { key: 'wemontaci', zone: ZONES.wemontaci, postal: clean };
            }
            return { key: 'hors', zone: null, postal: clean };
        }

        // Must start with G9X — everything else is hors zone
        if (prefix3 !== 'G9X') {
            return { key: 'hors', zone: null, postal: clean };
        }

        // G9X exceptions → région (250$)
        if (G9X_REGION_EXCEPTIONS[clean]) {
            return { key: 'region', zone: ZONES.region, postal: clean };
        }

        // All other G9X → La Tuque (100$)
        return { key: 'latuque', zone: ZONES.latuque, postal: clean };
    }

    /* ── Apply zone & update threshold ── */
    function applyZone(detection) {
        var msgEl = document.getElementById('dg-fs-postal-msg');
        var formEl = document.getElementById('dg-fs-postal-form');

        if (!detection || detection.key === 'hors') {
            // Out of zone — show error in badge area, keep form visible
            currentZone = null;
            THRESHOLD = 10000;
            if (msgEl) {
                msgEl.textContent = '⚠ Hors zone';
                msgEl.style.color = '#FF5757';
                msgEl.style.background = 'rgba(255,87,87,0.1)';
                msgEl.style.borderColor = 'rgba(255,87,87,0.2)';
            }
            return;
        }

        currentZone = detection;
        THRESHOLD = detection.zone.threshold;

        // Save to localStorage
        try {
            localStorage.setItem(LS_KEY, JSON.stringify({
                postal: detection.postal,
                zone: detection.key,
                threshold: THRESHOLD
            }));
        } catch (e) {}

        // Sync mobile header pin
        updateHeaderPin(detection.postal);

        if (formEl) formEl.style.display = 'none';
        if (msgEl) {
            msgEl.style.color = '';
            msgEl.style.background = '';
            msgEl.style.borderColor = '';
            msgEl.innerHTML = '';
        }

        // Re-render with updated threshold
        fetchAndRender();

        // Notify cart page bar to re-render with new zone
        document.dispatchEvent(new CustomEvent('dg:zone:changed'));

        // Auto-inject into Zapiet (Pickup + Delivery) cart widget when user sets zone on cart page
        injectIntoDeliveryWidget(detection.postal);
    }

    /* ── Load from localStorage on init ── */
    function loadSavedZone() {
        try {
            var saved = localStorage.getItem(LS_KEY);
            if (saved) {
                var data = JSON.parse(saved);
                if (data && data.zone && ZONES[data.zone]) {
                    currentZone = { key: data.zone, zone: ZONES[data.zone], postal: data.postal };
                    THRESHOLD = data.threshold || ZONES[data.zone].threshold;
                    return data.postal;
                }
            }
        } catch (e) {}
        return null;
    }

    /* ── Sync mobile header pin ── */
    function updateHeaderPin(postalCode) {
        var pin     = document.getElementById('dg-hdr-postal-pin');
        var codeEl  = document.getElementById('dg-hdr-postal-code');
        if (!pin || !codeEl) return;
        if (postalCode) {
            var formatted = postalCode.substring(0, 3) + '\u00a0' + postalCode.substring(3, 6);
            codeEl.textContent = formatted;
            pin.classList.add('has-zone');
            pin.title = 'Zone : ' + formatted + ' — Tap pour changer';
        } else {
            codeEl.textContent = '—';
            pin.classList.remove('has-zone');
            pin.title = 'Entrer ton code postal';
        }
    }

    /* ── CTA state helpers ── */
    function showCta() {
        var cta = document.getElementById('dg-postal-cta');
        var bar = document.getElementById('dg-fs-bar');
        if (cta) cta.classList.remove('dg-postal-cta--hidden');
        if (bar) {
            bar.classList.remove('dg-fs-bar--visible');
            bar.classList.remove('is-visible');
        }
    }

    function showBar() {
        var cta = document.getElementById('dg-postal-cta');
        var bar = document.getElementById('dg-fs-bar');
        if (cta) cta.classList.add('dg-postal-cta--hidden');
        if (bar) bar.classList.add('dg-fs-bar--visible');
    }

    /* ── Public: open postal input in CTA ── */
    window.dgFsOpenPostalInput = function () {
        var btn  = document.getElementById('dg-postal-cta-btn');
        var form = document.getElementById('dg-postal-cta-form');
        var inp  = document.getElementById('dg-fs-postal-input');
        if (btn)  btn.classList.add('dg-postal-cta__btn--hidden');
        if (form) form.classList.add('dg-postal-cta__form--open');
        if (inp)  { inp.value = ''; setTimeout(function () { inp.focus(); }, 80); }
    };

    /* ── Public: close CTA input (cancel) ── */
    window.dgFsCloseCta = function () {
        var btn  = document.getElementById('dg-postal-cta-btn');
        var form = document.getElementById('dg-postal-cta-form');
        var err  = document.getElementById('dg-postal-cta-error');
        if (btn)  btn.classList.remove('dg-postal-cta__btn--hidden');
        if (form) form.classList.remove('dg-postal-cta__form--open');
        if (err)  { err.textContent = ''; err.classList.remove('is-visible'); }
    };

    /* ── Public: check postal from form submit ── */
    window.dgFsCheckPostal = function (e) {
        if (e) e.preventDefault();
        var inp = document.getElementById('dg-fs-postal-input');
        if (!inp) return;
        var val = inp.value.trim();
        if (!val) return;
        var detection = detectZone(val);

        var err = document.getElementById('dg-postal-cta-error');
        
        if (detection && detection.key === 'invalid_length') {
            if (err) {
                err.textContent = '⚠ Code postal incomplet (6 lettres/chiffres requis)';
                err.classList.add('is-visible');
            }
            return;
        }

        if (detection && detection.key === 'hors') {
            // Show error in CTA
            if (err) {
                err.textContent = '⚠ Code postal hors zone de livraison';
                err.classList.add('is-visible');
            }
            return;
        }

        applyZone(detection);
        showBar();
    };

    /* ── Public: reset postal ── */
    window.dgFsResetPostal = function () {
        currentZone = null;
        THRESHOLD = 10000;
        try { localStorage.removeItem(LS_KEY); } catch (e) {}
        var msgEl = document.getElementById('dg-fs-postal-msg');
        var inp   = document.getElementById('dg-fs-postal-input');
        if (msgEl) { msgEl.innerHTML = ''; }
        if (inp)   { inp.value = ''; }
        updateHeaderPin(null);
        showCta();
        window.dgFsCloseCta();
        fetchAndRender();

        // Notify cart page bar to re-render with new zone
        document.dispatchEvent(new CustomEvent('dg:zone:changed'));
    };

    /**
     * WCP / WPD : aligné sur assets/dg-cart.js — cart.js garde souvent le catalogue,
     * window.wcp_data.wcp_cart.items porte wcp_v_price / wcp_vd_price (centimes / unité).
     */
    function dgFsFindWcpItemForCartLine(wcpItems, cartItem) {
        if (!wcpItems || !cartItem) return null;
        var k = cartItem.key;
        var id = cartItem.id;
        for (var j = 0; j < wcpItems.length; j++) {
            var wi = wcpItems[j];
            var oi = wi.original_item;
            if (oi && (oi.key === k || String(oi.id) === String(id))) return wi;
        }
        return null;
    }

    function dgFsWcpCartMatchesShopifyCart(cart) {
        var wcpItems = window.wcp_data && window.wcp_data.wcp_cart && window.wcp_data.wcp_cart.items;
        if (!cart || !cart.items || !wcpItems || wcpItems.length !== cart.items.length) return false;
        for (var i = 0; i < cart.items.length; i++) {
            var ci = cart.items[i];
            var wi = dgFsFindWcpItemForCartLine(wcpItems, ci);
            if (!wi || Number(wi.quantity) !== Number(ci.quantity)) return false;
        }
        return true;
    }

    function dgFsGetWcpLinePriceCentsForCartItem(cartItem) {
        var wcpItems = window.wcp_data && window.wcp_data.wcp_cart && window.wcp_data.wcp_cart.items;
        var wi = dgFsFindWcpItemForCartLine(wcpItems, cartItem);
        if (!wi) return null;
        var unit = wi.wcp_vd_price != null && wi.wcp_vd_price !== '' ? wi.wcp_vd_price : wi.wcp_v_price;
        if (unit == null || unit === undefined) return null;
        var n = Number(unit);
        if (isNaN(n)) return null;
        return Math.round(n * (cartItem.quantity || 1));
    }

    function dgFsGetWcpLineSumCents(cart) {
        if (!dgFsWcpCartMatchesShopifyCart(cart)) return null;
        var sum = 0;
        for (var i = 0; i < cart.items.length; i++) {
            var lineC = dgFsGetWcpLinePriceCentsForCartItem(cart.items[i]);
            if (lineC == null) return null;
            sum += lineC;
        }
        return sum;
    }

    /**
     * Montant (centimes) pour comparer au seuil livraison gratuite : wholesale si WCP aligné,
     * sinon cart.total_price (inchangé pour le retail).
     */
    function dgFsProgressMerchandiseCents(cart) {
        if (!cart) return 0;
        var w = dgFsGetWcpLineSumCents(cart);
        if (w == null) return cart.total_price || 0;
        var consigne = 0;
        cart.items.forEach(function (item) {
            if (item.sku === 'DG1') {
                var c = dgFsGetWcpLinePriceCentsForCartItem(item);
                consigne += c != null ? c : (item.final_line_price || 0);
            }
        });
        return w - consigne;
    }

    window.DG_fsProgressMerchandiseCents = dgFsProgressMerchandiseCents;

    /* ── Label text (Responsive Desktop/Mobile) ── */
    function labelFromCart(cart) {
        var basis = dgFsProgressMerchandiseCents(cart);
        var remaining = THRESHOLD - basis;
        var hasItems = (cart.item_count || 0) > 0;
        
        var formattedPostal = currentZone ? currentZone.postal.substring(0, 3) + ' ' + currentZone.postal.substring(3, 6) : '';
        var formattedPostalSafe = escapeHtml(formattedPostal);

        // Universal action: " (G9X 1V4) ✎" - compact and elegant for both views
        var postalAction = currentZone ? '&nbsp;&nbsp;<span class="dg-fs-postal-edit" onclick="dgFsResetPostal()" style="padding:2px 8px;">(' + formattedPostalSafe + ') ✎</span>' : '';

        if (!currentZone) {
            // No zone set yet — prompt
            return truckSvg + ' <span class="dg-fs-text-desktop">Entre ton code postal pour voir ta livraison gratuite</span><span class="dg-fs-text-mobile">Vérifie ta livraison gratuite</span>';
        }
        if (!hasItems) {
            return truckSvg + ' <span class="dg-fs-text-desktop">Livraison gratuite d&egrave;s&nbsp;<strong>' + currentZone.zone.label + '</strong></span><span class="dg-fs-text-mobile">Livraison gratuite d&egrave;s&nbsp;<strong>' + currentZone.zone.label + '</strong></span>' + postalAction;
        }
        if (remaining <= 0) {
            return checkSvg + ' <span class="dg-fs-text-desktop"><strong>Livraison gratuite</strong>&nbsp;d&eacute;bloqu&eacute;e</span><span class="dg-fs-text-mobile"><strong>Livraison gratuite !</strong></span>' + postalAction;
        }
        // Mobile text includes "livraison gratuite" but removes "la" to save space
        return truckSvg + ' <span class="dg-fs-text-desktop">Encore&nbsp;<strong>' + fmt(remaining) + '</strong>&nbsp;pour la livraison gratuite</span><span class="dg-fs-text-mobile">Encore&nbsp;<strong>' + fmt(remaining) + '</strong>&nbsp;pour livraison gratuite</span>' + postalAction;
    }

    /* ── Compute pct ── */
    function pctFromCart(cart) {
        return Math.min((dgFsProgressMerchandiseCents(cart) / THRESHOLD) * 100, 100);
    }

    /* ── Sparkles ── */
    function spawnSparkles(el) {
        if (!el) return;
        var rect = el.getBoundingClientRect();
        for (var i = 0; i < 8; i++) {
            (function (idx) {
                setTimeout(function () {
                    var p = document.createElement('span');
                    p.className = 'dg-fs-sparkle';
                    p.style.left = (rect.left + Math.random() * rect.width) + 'px';
                    p.style.top = (rect.top + Math.random() * rect.height) + 'px';
                    p.style.setProperty('--dx', (Math.random() * 40 - 20) + 'px');
                    p.style.setProperty('--dy', (Math.random() * -40 - 10) + 'px');
                    document.body.appendChild(p);
                    setTimeout(function () { p.remove(); }, 700);
                }, idx * 60);
            })(i);
        }
    }

    /* ── Confetti ── */
    function confettiBurst(el) {
        var colors = ['#4DA3FF', '#7dd3fc', '#34d399', '#fbbf24', '#f472b6', '#a78bfa', '#fb923c'];
        var rect = el ? el.getBoundingClientRect() : null;
        if (!rect) return;
        var cx = rect.left + rect.width / 2;
        var cy = rect.top;
        for (var i = 0; i < 28; i++) {
            (function (idx) {
                setTimeout(function () {
                    var p = document.createElement('span');
                    p.className = 'dg-fs-sparkle dg-fs-confetti';
                    var color = colors[idx % colors.length];
                    p.style.background = color;
                    p.style.boxShadow = '0 0 6px ' + color;
                    p.style.width = (Math.random() * 5 + 4) + 'px';
                    p.style.height = (Math.random() * 5 + 4) + 'px';
                    p.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';
                    var angle = (idx / 28) * Math.PI * 2;
                    var dist = 60 + Math.random() * 80;
                    p.style.left = (cx + Math.cos(angle) * 10) + 'px';
                    p.style.top = (cy + Math.sin(angle) * 10) + 'px';
                    p.style.setProperty('--dx', (Math.cos(angle) * dist) + 'px');
                    p.style.setProperty('--dy', (Math.sin(angle) * dist - 60) + 'px');
                    document.body.appendChild(p);
                    setTimeout(function () { p.remove(); }, 900);
                }, idx * 35);
            })(i);
        }
    }

    /* ══════════════════════════════════
       RENDER
       ══════════════════════════════════ */
    function render(cart, isUpdate) {
        var pct = pctFromCart(cart);
        var hasItems = (cart.item_count || 0) > 0;
        var increased = pct > prevPct;
        prevPct = pct;

        var barEl = document.getElementById('dg-fs-bar');
        var fillEl = document.getElementById('dg-fs-bar-fill');
        var lblEl = document.getElementById('dg-fs-bar-label');
        var truckEl = document.getElementById('dg-fs-truck');

        if (barEl && currentZone) barEl.classList.add('is-visible');
        if (fillEl) fillEl.style.width = (hasItems && currentZone ? pct : 0) + '%';
        if (lblEl) lblEl.innerHTML = labelFromCart(cart);

        /* Position the truck at the fill edge */
        if (truckEl) {
            var showTruck = hasItems && currentZone && pct > 0;
            truckEl.style.opacity = showTruck ? '1' : '0';
            truckEl.style.left = (hasItems && currentZone ? pct : 0) + '%';
        }

        /* Cart button pulse */
        var cartBtn = document.getElementById('dg-topbar-cart-btn');
        if (cartBtn) cartBtn.classList.toggle('has-items', hasItems);

        /* Free/not-free state */
        if (barEl) {
            if (pct >= 100 && currentZone) {
                barEl.classList.add('dg-fs-bar--free');
            } else {
                barEl.classList.remove('dg-fs-bar--free');
            }
        }

        /* Sparkles on increase */
        if (isUpdate && increased && pct < 100 && currentZone) {
            spawnSparkles(fillEl);
        }

        /* Free unlock celebration (once) */
        if (pct >= 100 && currentZone && !hasCelebratedFree) {
            hasCelebratedFree = true;
            confettiBurst(barEl);
            if (barEl) {
                barEl.classList.remove('dg-fs-bar--pulse');
                void barEl.offsetWidth;
                barEl.classList.add('dg-fs-bar--pulse');
                setTimeout(function () { barEl.classList.remove('dg-fs-bar--pulse'); }, 2400);
            }
        } else if (pct < 100) {
            hasCelebratedFree = false;
        }
    }

    /* ── Fetch cart and render ── */
    function fetchAndRender() {
        fetch(ROOT + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                window.DG_cartItems = cart.items || [];
                render(cart, false);
            })
            .catch(function () {});
    }

    /* ── Listen to cart updates ── */
    document.addEventListener('dg:cart:updated', function (e) {
        var cart = e.detail && e.detail.cart;
        if (cart) render(cart, true);
    });

    /* ── Auto-inject postal code into Zapiet cart widget on cart page ── */
    function injectIntoDeliveryWidget(postalCode) {
        if (!postalCode) return;
        // Only run on the cart page
        if (window.location.pathname.indexOf('/cart') === -1) return;

        function getDeliveryWidgetRoot() {
            return document.getElementById('storePickupApp')
                || document.getElementById('StorePickupApp')
                || document.querySelector('[class*="zapiet"]')
                || document.querySelector('[class*="Zapiet"]');
        }

        /* React-compatible value setter — required for app widget internal state */
        function setNativeValue(input, value) {
            var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
            if (setter && setter.set) {
                setter.set.call(input, value);
            } else {
                input.value = value;
            }
            input.dispatchEvent(new Event('input',  { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        /* Postal / zip field inside Zapiet widget */
        function findPostalInput() {
            var root = getDeliveryWidgetRoot();
            if (root) {
                var inputs = root.querySelectorAll('input[type="text"], input[type="search"], input:not([type])');
                for (var i = 0; i < inputs.length; i++) {
                    var inp = inputs[i];
                    var hint = [
                        inp.placeholder || '',
                        inp.name || '',
                        inp.id || '',
                        inp.getAttribute('aria-label') || ''
                    ].join(' ').toLowerCase();
                    if (hint.indexOf('postal') !== -1 || hint.indexOf('zip') !== -1 || hint.indexOf('code') !== -1) {
                        return inp;
                    }
                }
                if (inputs.length) return inputs[0];
            }
            return null;
        }

        var attempts = 0;
        var maxAttempts = 30; // ~15 seconds

        function tryInject() {
            attempts++;
            var ddInput = findPostalInput();

            if (ddInput) {
                var currentVal = (ddInput.value || '').replace(/\s/g, '').toUpperCase();
                var targetVal  = postalCode.replace(/\s/g, '').toUpperCase();
                if (currentVal === targetVal) return; // already correct

                // Format with space: "G9X1E4" → "G9X 1E4"
                var formatted = postalCode.length === 6
                    ? postalCode.substring(0, 3) + ' ' + postalCode.substring(3)
                    : postalCode;

                setNativeValue(ddInput, formatted);

                // Trigger validation: Enter key + first visible button in widget
                setTimeout(function () {
                    ddInput.dispatchEvent(new KeyboardEvent('keydown', {
                        key: 'Enter', code: 'Enter', keyCode: 13, bubbles: true
                    }));
                    var container = getDeliveryWidgetRoot();
                    if (container) {
                        var btn = container.querySelector('button[type="submit"], button:not([type])');
                        if (btn && btn.offsetParent !== null) btn.click();
                    }
                }, 200);
                return; // done
            }

            if (attempts < maxAttempts) {
                setTimeout(tryInject, 500);
            }
        }

        // Start immediately or after DOM ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () { setTimeout(tryInject, 500); });
        } else {
            setTimeout(tryInject, 500);
        }

        // Watch for Zapiet widget being dynamically inserted
        if (_deliveryWidgetObserver) {
            _deliveryWidgetObserver.disconnect();
            _deliveryWidgetObserver = null;
        }

        var observer = new MutationObserver(function () {
            if (getDeliveryWidgetRoot()) {
                observer.disconnect();
                _deliveryWidgetObserver = null;
                setTimeout(tryInject, 400);
            }
        });
        _deliveryWidgetObserver = observer;
        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () {
            observer.disconnect();
            _deliveryWidgetObserver = null;
        }, 20000);
    }

    /* ── Init ── */
    function init() {
        /* ── SESSION MANAGEMENT ──────────────────────────────────────────────────
         *  dg_postal_zone (localStorage) is CLEARED on every new browser session.
         *  Exception: logged-in customer with a valid default address postal code
         *  (exposed via window.DG_CUSTOMER_POSTAL from theme.liquid).
         *  Within a session, the postal persists across page navigations.
         * ─────────────────────────────────────────────────────────────────────── */
        var SESSION_KEY = 'dg_session_init';
        if (!sessionStorage.getItem(SESSION_KEY)) {
            if (window.DG_CUSTOMER_POSTAL) {
                // Logged-in customer → detect & set their delivery zone automatically
                var cDetection = detectZone(window.DG_CUSTOMER_POSTAL);
                if (cDetection && cDetection.key !== 'hors') {
                    try {
                        localStorage.setItem(LS_KEY, JSON.stringify({
                            postal:    cDetection.postal,
                            zone:      cDetection.key,
                            threshold: cDetection.zone.threshold
                        }));
                    } catch (e) {}
                } else {
                    // Customer's address is out-of-zone → start fresh
                    try { localStorage.removeItem(LS_KEY); } catch (e) {}
                }
            } else {
                // Anonymous visitor → wipe any stale zone from a previous session
                try { localStorage.removeItem(LS_KEY); } catch (e) {}
            }
            sessionStorage.setItem(SESSION_KEY, '1');
        }

        // Restore the postal zone for this session (customer- or user-set)
        var savedPostal = loadSavedZone();
        if (savedPostal && currentZone) {
            // Has a valid zone — skip CTA, go straight to bar
            var msgEl = document.getElementById('dg-fs-postal-msg');
            if (msgEl) {
                msgEl.innerHTML = '';
            }
            updateHeaderPin(savedPostal);
            showBar();

            // Auto-inject into Zapiet cart widget on cart page
            injectIntoDeliveryWidget(savedPostal);
        } else {
            // No valid zone — show the CTA prompt
            showCta();
        }
        fetchAndRender();
        dgStartZapietSlotMenuTextFix();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

})();
